import { render, staticRenderFns } from "./PromotionScreenPage.vue?vue&type=template&id=2c136fa3&scoped=true&"
import script from "./PromotionScreenPage.vue?vue&type=script&lang=js&"
export * from "./PromotionScreenPage.vue?vue&type=script&lang=js&"
import style0 from "./PromotionScreenPage.vue?vue&type=style&index=0&id=2c136fa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c136fa3",
  null
  
)

export default component.exports